// UserInfoProvider.jsx
import { createContext, useState, useEffect } from 'react';
import { useSession } from '../libraries/UseSession';
import cookie from 'js-cookie';

export const UserInfoContext = createContext();

export const UserInfoProvider = ({ children }) => {
    // セッション定義
    const {
        getSessionToken, setSessionToken, removeSessionToken,                  // トークン情報
        getSessionUserInfo, setSessionUserInfo, removeSessionUserInfo,         // ユーザ情報
    } = useSession();

    // システム管理者権限
    let _token = getSessionToken();
    if (_token === null) {
        _token = "";
    }
    const [token, setToken] = useState(_token);

    useEffect(() => {
        if (token !== "") {
            // セッション情報を登録
            setSessionToken(token);
            // cookieに保存する
            cookie.set("token", token);
        } else {
            // セッションを削除
            removeSessionToken();
            // cookieからも削除
            cookie.remove("token");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    // ユーザ情報
    let _userInfo = getSessionUserInfo();
    if (_userInfo === null) {
        _userInfo = null; // Use null instead of empty string for objects
    }
    const [userInfo, setUserInfo] = useState(_userInfo);

    useEffect(() => {
        if (userInfo !== null && userInfo !== "") {
            // セッション情報を登録
            setSessionUserInfo(userInfo);
        } else {
            // セッションを削除
            removeSessionUserInfo();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userInfo]);

    // プロバイダー定義
    const providerValue = {
        token, setToken, removeSessionToken,
        userInfo, setUserInfo, removeSessionUserInfo,
    };

    return (
        <UserInfoContext.Provider value={providerValue}>
            {children}
        </UserInfoContext.Provider>
    );
}